export function detectAcademySlug(): string | null {
  const parts = window.location.hostname.split('.');
  // "greenwood.platform.com" → 3 parts → slug = parts[0]
  // Exclude common non-academy prefixes like "www"
  if (parts.length >= 3 && parts[0] !== 'www') return parts[0];
  // Fallback: ?academy=slug query param (for root-domain access)
  const params = new URLSearchParams(window.location.search);
  return params.get('academy');
}
